import * as Application from 'expo-application';
import { useNavigation } from 'expo-router';
import { useLayoutEffect } from 'react';
import { Platform, StyleSheet, useColorScheme, View } from 'react-native';
import { FlatList } from 'react-native-gesture-handler';
import { Divider } from 'react-native-paper';

import GoBackButton from '@/components/buttons/GoBackButton';
import { OptionItem } from '@/components/settings/OptionItem';
import Text from '@/components/Text';
import Title from '@/components/Title';
import { Colors } from '@/constants/Colors';
import { menuOptions } from '@/constants/enums/SettingsRoutes';
import { useAuth } from '@/contexts/authContext';
import { i18n } from '@/utils/i18n';

const SettingsScreen = () => {
  const colorScheme = useColorScheme();
  const navigation = useNavigation();
  const { state } = useAuth();

  // Locales
  const settings = i18n.t('settings.title');

  useLayoutEffect(() => {
    navigation.setOptions({
      headerTitle: () => <Title label={settings} />,
      headerLeft: () => <GoBackButton />
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const appVersion = `v${Application.nativeApplicationVersion}-b${Application.nativeBuildVersion}`;

  const menuItems = menuOptions.filter(
    (item) => (state.user?.user?.role && item.userType.includes(state.user?.user?.role)) || item.userType[0] === 'ALL'
  );

  return (
    <View style={[style.container, { backgroundColor: Colors[colorScheme === 'dark' ? 'dark' : 'light'].background }]}>
      <FlatList
        showsVerticalScrollIndicator={false}
        style={style.optionsList}
        data={menuItems}
        ItemSeparatorComponent={() => <Divider />}
        renderItem={({ item }) => (
          <OptionItem screen={item.screen} icon={item.icon} label={item.label} userType={item.userType} />
        )}
        //Only for mobile app
        {...(Platform.OS !== 'web' && {
          ListFooterComponent: <Text style={style.appVersionStyleText}>{appVersion}</Text>,
          contentContainerStyle: { paddingHorizontal: 16 }
        })}
        ListFooterComponentStyle={style.appVersionStyle}
      />
    </View>
  );
};

export default SettingsScreen;

const style = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    paddingTop: 12
  },

  optionsList: {
    width: '100%'
  },

  appVersionStyleText: {
    color: 'rgba(0,0,0,0.5)'
  },

  appVersionStyle: {
    marginTop: 25,
    flexDirection: 'row',
    justifyContent: 'center'
  }
});
